// Studyo Today Backend
// Package studyo.today.google_calendar.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/google_calendar/v1/resources/sync_status.proto (package studyo.today.google_calendar.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_google_calendar_v1_resources_sync_blocker } from "./sync_blocker_pb.js";

/**
 * Describes the file studyo/today/google_calendar/v1/resources/sync_status.proto.
 */
export const file_studyo_today_google_calendar_v1_resources_sync_status = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvZ29vZ2xlX2NhbGVuZGFyL3YxL3Jlc291cmNlcy9zeW5jX3N0YXR1cy5wcm90bxIpc3R1ZHlvLnRvZGF5Lmdvb2dsZV9jYWxlbmRhci52MS5yZXNvdXJjZXMi+QEKClN5bmNTdGF0dXMSIgoaaXNfY3VycmVudGx5X3N5bmNocm9uaXppbmcYASABKAgSPQoZbGFzdF9zdWNjZXNzZnVsX3N5bmNfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASTQoNc3luY19ibG9ja2VycxgDIAMoDjI2LnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEucmVzb3VyY2VzLlN5bmNCbG9ja2VyEh0KFW1pc3NpbmdfZ29vZ2xlX3Njb3BlcxgEIAMoCRIaChJsYXN0X3N5bmNfdHJhY2VfaWQYBSABKAlCMKoCLVN0dWR5by5Ub2RheS5Hb29nbGVDYWxlbmRhci5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_google_calendar_v1_resources_sync_blocker]);

/**
 * Describes the message studyo.today.google_calendar.v1.resources.SyncStatus.
 * Use `create(SyncStatusSchema)` to create a new message.
 */
export const SyncStatusSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_resources_sync_status, 0);

